module.exports = __webpack_public_path__ + "static/media/action-response.39838743.svg";